export default function isPast(date) {
    return new Date(date).getTime() < Date.now();
};
